/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  GuardrailConfig,
  GuardrailConfig$inboundSchema,
  GuardrailConfig$Outbound,
  GuardrailConfig$outboundSchema,
} from "./guardrailconfig.js";

export type UpdateGuardrailsRequest = {
  /**
   * List of guardrails to configure
   */
  guardrails: Array<GuardrailConfig>;
  /**
   * Target team for this policy. Omit or pass null to set the org-wide policy that applies to every team (org admin only). Non-admin callers may only target their own team.
   */
  teamId?: string | null | undefined;
};

/** @internal */
export const UpdateGuardrailsRequest$inboundSchema: z.ZodType<
  UpdateGuardrailsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  guardrails: z.array(GuardrailConfig$inboundSchema),
  team_id: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    "team_id": "teamId",
  });
});
/** @internal */
export type UpdateGuardrailsRequest$Outbound = {
  guardrails: Array<GuardrailConfig$Outbound>;
  team_id?: string | null | undefined;
};

/** @internal */
export const UpdateGuardrailsRequest$outboundSchema: z.ZodType<
  UpdateGuardrailsRequest$Outbound,
  z.ZodTypeDef,
  UpdateGuardrailsRequest
> = z.object({
  guardrails: z.array(GuardrailConfig$outboundSchema),
  teamId: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    teamId: "team_id",
  });
});

export function updateGuardrailsRequestToJSON(
  updateGuardrailsRequest: UpdateGuardrailsRequest,
): string {
  return JSON.stringify(
    UpdateGuardrailsRequest$outboundSchema.parse(updateGuardrailsRequest),
  );
}
export function updateGuardrailsRequestFromJSON(
  jsonString: string,
): SafeParseResult<UpdateGuardrailsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateGuardrailsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateGuardrailsRequest' from JSON`,
  );
}
